import {Injectable, Inject} from '@angular/core';
import {MacroService} from './services/macro.service';

@Injectable()
export class Utilities {

  constructor(@Inject(MacroService) public macroService: MacroService) {
  }

  obtenerImagenesFormulario(elementos) {
    try {
      if (elementos) {
        return elementos.filter(elm => (elm.identificador.toLowerCase().indexOf('takepicture') !== -1 || elm.identificador.toLowerCase().indexOf('masterdetails') !== -1));
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  obtenerFirmasFormulario(elementos) {
    try {
      if (elementos) {
        return elementos.filter(elm => (elm.identificador.toLowerCase().indexOf('firma') !== -1 || elm.identificador.toLowerCase().indexOf('masterdetails') !== -1));
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  obtenerElementosDeMaestroFormulario(maestro) {
    try {
      if (maestro) {
        return maestro.plantilla.elementosRepetitivos;
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  obtenerElementosImagenesDeMaestroFormulario(maestro) {
    try {
      if (maestro.plantilla.elementosRepetitivos) {
        return maestro.plantilla.elementosRepetitivos.filter(elm => elm.identificador.toLowerCase().indexOf('takepicture') !== -1);
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  obtenerElementosFirmasDeMaestroFormulario(maestro) {
    try {
      if (maestro.plantilla.elementosRepetitivos) {
        return maestro.plantilla.elementosRepetitivos.filter(elm => elm.identificador.toLowerCase().indexOf('firma') !== -1);
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  obtenerNumericosCalculadorasFormulario(elementos) {
    try {
      if (elementos) {
        return elementos.filter(elm => (elm.tipo.toLowerCase().indexOf('numero') !== -1) || (elm.tipo.toLowerCase().indexOf('calculadora') !== -1));
      }
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  preparDatosFormularioPDF(formulario, pagina, elemento) {
    try {
      var form_x = formulario;
      form_x.paginas = form_x.paginas.filter(pag => pag.numero === pagina.numero);
      form_x.paginas[0].elementos = form_x.paginas[0].elementos.filter(elm => elm.id === elemento.id);
      if (form_x.paginas[0].elementos.length > 0) {
        var form = {
          id: formulario.id,
          pagina: {
            id: form_x.paginas[0].numero,
            elemento: form_x.paginas[0].elementos.length > 0 ? form_x.paginas[0].elementos[0].id : '',
          },
        };
        return {'form_show': form_x, 'form_save': form};
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  perpararDatosMaestroPDF(formulario, pagina, master, all, elmMaster) {
    try {
      let form_x = formulario;
      form_x.paginas = form_x.paginas.filter(pag => pag.numero === pagina.numero);
      form_x.paginas[0].elementos = form_x.paginas[0].elementos.filter(elm => elm.id === master.id);
      var form = {
        idMaestro: formulario.id,
        pagina: {},
      };
      if (!all) {
        if (form_x.paginas[0].elementos.length > 0) {
          form_x.paginas[0].elementos[0].plantilla.elementosRepetitivos = form_x.paginas[0].elementos[0].plantilla.elementosRepetitivos.filter(elm => elm.id === elmMaster.id);
          if (form_x.paginas[0].elementos[0].plantilla.elementosRepetitivos.length > 0) {
            form.pagina = {
              id: form_x.paginas[0].numero,
              elemento: form_x.paginas[0].elementos[0].plantilla.elementosRepetitivos.length > 0 ? form_x.paginas[0].elementos[0].plantilla.elementosRepetitivos[0].id : '',
            };
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        form_x.paginas[0].elementos[0].all = true;
        form.pagina = {
          id: form_x.paginas[0].id,
          elemento: 'todos',
        };
      }
      return {'form_show': form_x, 'form_save': form};
    } catch (e) {
      console.error(e);
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utilities.ts